import { useState, useRef, memo, useEffect } from 'react';
import * as Styled from './multi-select.styles';
import { useTranslation } from 'react-i18next';
import { FilterButton } from '../shared';
import { type FilterSelectProps } from '../../../../types';
import MultiSelectDropdown, { deselectAll } from './multi-select-dropdown.component';

const MultiSelect: React.FC<FilterSelectProps> = ({
  state,
  optionIds,
  labelKey,
  isOpen,
  search,
  singleSelect,
  commentIds,
  pinned,
  onRemoveFilter,
  onValueChange,
  onToggleFilter,
  onClickFilterOutside,
}) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const selectedIds = (optionIds || Object.keys(state)).filter((id) => state[id]?.active);

  const onRemoveFilterHandler = () => onRemoveFilter(deselectAll(state));

  const onClickFilterOutsideHandle = (isEmpty: boolean) => {
    if (isEmpty && !pinned) onRemoveFilterHandler();
    onClickFilterOutside();
  };

  const ref = useRef(null);

  useEffect(() => {
    setAnchorEl(isOpen ? ref.current : null);
  }, [isOpen]);

  return (
    <Styled.Wrapper ref={ref}>
      <FilterButton
        isActive={isOpen}
        action="delete"
        iconSize={16}
        iconViewBox="-1 -1 14 14"
        onToggleFilter={!pinned ? onRemoveFilterHandler : null}
        onClick={onToggleFilter}
      >
        <Styled.SelectedInfoContainer>
          <Styled.FirstSelectedValue>
            {`${t(labelKey)}${selectedIds.length ? `: ${state[selectedIds[0]].title}` : ''}`}
          </Styled.FirstSelectedValue>
          {selectedIds.length > 1 && <Styled.SelectedCount>+{selectedIds.length - 1}</Styled.SelectedCount>}
        </Styled.SelectedInfoContainer>
      </FilterButton>
      <MultiSelectDropdown
        anchorEl={anchorEl}
        state={state}
        optionIds={optionIds}
        search={search}
        singleSelect={singleSelect}
        commentIds={commentIds}
        onValueChange={onValueChange}
        onClose={onClickFilterOutsideHandle}
      />
    </Styled.Wrapper>
  );
};

export default memo(MultiSelect);
